// Commands
export const ADD_BUTTON_TOOLTIP = 'Create new row';
export const EDIT_BUTTON_TOOLTIP = 'Edit row';
export const DELETE_BUTTON_TOOLTIP = 'Delete row';
export const COMMIT_BUTTON_TOOLTIP = 'Save changes';
export const CANCEL_BUTTON_TOOLTIP = 'Cancel changes';
export const WINDOW_CONFIRM_DELETE = 'Are you sure you want to delete this row?';

// LookupEditCell & conditions object(affectedColTargets -> columnConfig -> type) and columns array (type) inside the const file of component that using the instance of GenericTable
export const COLUMN_TYPES = {
	SELECT: 'select',
	EDITABLE_SELECT: 'editableSelect',
	INPUT: 'input',
	DATE: 'date',
	ACTION: 'action',
	CHECKBOX: 'checkbox',
};
export const DEFAULT_MIN_WIDTH_SELECT_DD = 7;
export const DISPLAY_KEY = 'display';
export const VALUE_KEY = 'value';
export const SELECT_PLACEHOLDER = 'Select... ';
